import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LanguageProvider } from './context/LanguageContext';
import { NavbarProvider } from './context/NavbarContext';
import { OverlayProvider } from './context/OverlayContext';
import { ToastProvider } from './components/Toast/ToastContext';
import { RouterProvider } from 'react-router-dom';
import { Router } from './Router';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// React Query configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (replaces cacheTime)
      retry: 1, // Retry failed requests once
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnReconnect: true, // Refetch on reconnect
    },
    mutations: {
      retry: 0, // Don't retry mutations
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <NavbarProvider>
          <OverlayProvider>
            <ToastProvider>
              <RouterProvider router={Router} />
              {/* {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />} */}
            </ToastProvider>
          </OverlayProvider>
        </NavbarProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App;
